import EducationFormConnect, { EducationFairFormConnectProps } from './EducationFairForm'
import EnquiryFormConnect, { EnquiryFormConnectProps } from './EnquiryForm'

export { EducationFormConnect, EnquiryFormConnect }
export type { EducationFairFormConnectProps, EnquiryFormConnectProps }
